import { gql } from '@apollo/client'

export const InsertContentItemsFromHtml = gql`
    mutation insertContentItemsFromHtml(
        $input: InsertContentItemsFromHtmlInput!
    ) {
        insertContentItemsFromHtml(input: $input) {
            instanceId
            warnings
        }
    }
`
